import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { MdCheckCircle } from 'react-icons/md';
import { useToast } from '../components/ToastProvider';
import pointfinityLogo from '../assets/pointfinity-logo-mark.png';
import './PageStyles.css';

// ✏️ Update these URLs when apps are live
const appStoreUrl = '#';
const playStoreUrl = '#';

const appFeatures = [
  'Track loyalty points in real time',
  'Browse and claim store offers',
  'Redeem points at checkout',
  'View transaction history',
  'Get push notifications for new deals',
  'Manage profile & linked stores',
];

export default function DownloadApp() {
  const toast = useToast();

  const handleStore = (e, store) => {
    e.preventDefault();
    toast({ message: `${store} link coming soon! App launching shortly.`, type: 'info' });
  };
  return (
    <div className="page">
      <div className="page-hero hero-gradient">
        <div className="container text-center">
          <span className="section-label" style={{ background: 'rgba(103,183,247,0.15)', color: 'var(--secondary)' }}>
            Mobile App
          </span>
          <h1>Download Pointfinity App</h1>
          <p>Everything your customers need to track points, discover offers, and redeem rewards — in their pocket.</p>
        </div>
      </div>

      <section className="light-gradient">
        <div className="container download-page__inner">
          <div className="download-page__info">
            <h2>One app. All your rewards.</h2>
            <p>
              The Pointfinity app connects customers to their favorite stores. Earn points on every visit, get notified about new offers, and redeem rewards in seconds.
            </p>
            <ul className="download-page__features">
              {appFeatures.map((f) => (
                <li key={f}><MdCheckCircle /> {f}</li>
              ))}
            </ul>
            <div className="download-page__btns">
              <a href={appStoreUrl} className="store-btn-dark" aria-label="Download on App Store" onClick={(e) => handleStore(e, 'App Store')}>
                <FaApple />
                <div>
                  <span>Download on the</span>
                  <strong>App Store</strong>
                </div>
              </a>
              <a href={playStoreUrl} className="store-btn-dark" aria-label="Get it on Google Play" onClick={(e) => handleStore(e, 'Google Play')}>
                <FaGooglePlay />
                <div>
                  <span>Get it on</span>
                  <strong>Google Play</strong>
                </div>
              </a>
            </div>
          </div>
          <div className="download-page__mockup">
            <div className="phone-big">
              <div className="phone-big__notch" />
              <div className="phone-big__screen">
                <img src={pointfinityLogo} alt="Pointfinity logo" className="phone-big__logo" />
                <p>Pointfinity</p>
                <span>Your Rewards Hub</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
